import RouteTemplate from 'ember-route-template';

export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <div class="pd-best-for__hero">
        <h1 class="pd-best-for__title">Proxy Glossary</h1>
        <p class="pd-best-for__subtitle">
          Learn proxy terminology — clear definitions of common proxy terms, protocols, and technologies.
        </p>
      </div>
    
      <div class="pd-guides__grid">
        {{#each @controller.model.guides as |g|}}
          <a class="pd-guide-card" href={{g.url}}>
            <div class="pd-guide-card__body">
              <span class="pd-guide-card__category">{{g.categoryLabel}}</span>
              <h3 class="pd-guide-card__title">{{g.title}}</h3>
              {{#if g.excerpt}}
                <p class="pd-guide-card__excerpt">{{g.excerpt}}</p>
              {{/if}}
              <span class="pd-guide-card__read-time">{{g.read_time_minutes}} min read</span>
            </div>
          </a>
        {{else}}
          <div class="pd-empty">
            <div class="pd-empty__icon">📖</div>
            <div class="pd-empty__title">Glossary coming soon</div>
            <div class="pd-empty__body">Proxy terminology definitions are being prepared. Check back shortly.</div>
          </div>
        {{/each}}
      </div>
    </section>

  </template>
);
